/* custom-rtl.js — Dawn slider fixes for <html dir="rtl">.
   Loaded after global.js (see snippets/custom-rtl-head.liquid).
   In RTL, scrollLeft runs 0 → negative and Dawn's sliderItemOffset comes out
   negative, so next/prev already scroll the right way. What breaks is the
   page count (measured from the first slide's LEFT edge) and the slideshow's
   wrap-around / dot navigation, which assume a positive axis. */
(() => {
  if (document.documentElement.dir !== 'rtl') return;

  const Slider = customElements.get('slider-component');
  const Slideshow = customElements.get('slideshow-component');
  if (!Slider) return;

  const initPages = Slider.prototype.initPages;
  Slider.prototype.initPages = function () {
    initPages.call(this);
    if (!this.sliderItemsToShow || this.sliderItemsToShow.length < 2) return;
    const first = this.sliderItemsToShow[0];
    const firstEdge = this.slider.clientWidth - (first.offsetLeft + first.clientWidth);
    this.slidesPerPage = Math.floor((this.slider.clientWidth - firstEdge) / Math.abs(this.sliderItemOffset));
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  };

  if (!Slideshow) return;

  const onButtonClick = Slideshow.prototype.onButtonClick;
  Slideshow.prototype.onButtonClick = function (event) {
    onButtonClick.call(this, event);
    // Dawn wraps first → last by scrolling +width*n; the RTL end is at -width*n.
    if (this.currentPage === 1 && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft - this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      this.setSlidePosition(this.slideScrollPosition);
    }
  };

  Slideshow.prototype.linkToSlide = function (event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft -
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  };
})();
